import { render, staticRenderFns } from "./dvn_job.vue?vue&type=template&id=f89db76c&scoped=true"
import script from "./dvn_job.vue?vue&type=script&lang=js"
export * from "./dvn_job.vue?vue&type=script&lang=js"
import style0 from "./dvn_job.vue?vue&type=style&index=0&id=f89db76c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89db76c",
  null
  
)

export default component.exports